import React from "react";
import { BrowserRouter, Route, Switch, useRouteMatch } from "react-router-dom";
import Home from "./pages/home/Home";
import usersList from "./pages/usersList/UsersList";
import NotFound from "./pages/NotFound";
import Layout from "./components/Layout";
import ProductList from "./pages/productList/ProductList";
import Errands from "./pages/errands/Errands";
import Messages from "./pages/messages/Messages";
import Orders from "./pages/orders/Orders";
import PraviteRoute from "./Auth/PrivateRoute";
import FAuth from "./Auth/FAuth";
import loginIn from "./components/LoginIn/LoginIn";
import DeliverdItems from "./pages/deliverd/index";
import Restaurants from "./pages/resturants/index";

function Routes() {
  return (
    <FAuth>
      <BrowserRouter>
        <Route
          render={(props) => (
            <Layout {...props}>
              <Switch>
                <PraviteRoute path="/dashboard" exact component={Home} />
                <PraviteRoute path="/products" exact component={ProductList} />
                <PraviteRoute path="/users" exact component={usersList} />
                <PraviteRoute path="/errands" exact component={Errands} />
                <PraviteRoute path="/messages" exact component={Messages} />
                <PraviteRoute path="/orders" exact component={Orders} />
                <PraviteRoute path="/restaurants" exact component={Restaurants} />
                <PraviteRoute
                  path="/ordersdelivered"
                  exact
                  component={DeliverdItems}
                />
                <PraviteRoute path="/" exact component={Home} />
                <Route exact path="/login" component={loginIn}></Route>
                <PraviteRoute component={NotFound} />
              </Switch>
            </Layout>
          )}
        />
      </BrowserRouter>
    </FAuth>
  );
}

export default Routes;

//   <Route path="/" exact component={Home}/>
//                         <Route path="/dashboard" exact component={Home}/>
//                         <Route path="/products" component={ProductList}/>
//                         <Route path="/users" component={usersList}/>
//                         <Route path="/errands" component={Errands}/>
//                         <Route path="/messages" component={Messages}/>
//                         <Route path="/orders" component={Orders}/>
//                         <Route component={NotFound}/>
